<template>
  <div>
    <p>エラー</p>
  </div>
</template>

<style lang="sass">
@import "~/assets/scss/mixins.sass"

</style>

<script>
export default {
  props: ['error'],
  mounted() {
    console.log('エラー')
  }
}
</script>
